import React from "react";
import Modal from "./Modal";
import { geohazards, issuePropertyOptions, getLabelByValue } from "../constants/formOptions";

function ModalIssue({ isOpen, onClose, issue }) {

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={handleClose} className="large">
      <div className="modal-add-data-file">
        <h6>Existing Issue: {getLabelByValue(geohazards, issue.geohazardType)}</h6>
        <p>Description: {issue.description}</p>
        <ul>
          {issue && Object.entries(issue.issueProperties).map(([k, v]) => {
            const g = geohazards.find(type => type.value === issue.geohazardType);
            const p = g.properties.find(i => i.value === k);
            const o = issuePropertyOptions[p.value].find(i => i.value === v);
            return <li key={k}><b>{p?.label}:</b> {o?.label}</li>;
          })}
        </ul>
      </div>
      <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
        <button className="button-outline outline" onClick={handleClose}>
          Close
        </button>
      </div>
    </Modal>
  );
}

export default ModalIssue;
